import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/board/excel_ico.png'


const _withScopeId = n => (_pushScopeId("data-v-0bca79f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "content_layer" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { id: "board_layer" }
const _hoisted_6 = { class: "board_top" }
const _hoisted_7 = { class: "board_top_btns" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "엑셀다운로드", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "board_top_btns_right" }
const _hoisted_12 = { class: "count" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "20" }, "20", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "50" }, "50", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "70" }, "70", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "100" }, "100", -1))
const _hoisted_17 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "board_cate_btns" }
const _hoisted_19 = { class: "chk" }
const _hoisted_20 = ["value"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "gal_thumb_img" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "gal_thumb_info_div" }
const _hoisted_26 = { class: "gal_info_list left" }
const _hoisted_27 = { class: "gal_info_top" }
const _hoisted_28 = { class: "gal_info_tit" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "순번", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "고유번호", -1))
const _hoisted_31 = { class: "gal_info_con" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "플랫폼", -1))
const _hoisted_33 = {
  key: 0,
  class: "gal_info_con"
}
const _hoisted_34 = {
  key: 1,
  class: "gal_info_con"
}
const _hoisted_35 = {
  key: 2,
  class: "gal_info_con"
}
const _hoisted_36 = {
  key: 3,
  class: "gal_info_con"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "제목", -1))
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "링크", -1))
const _hoisted_40 = { class: "gal_info_con" }
const _hoisted_41 = ["href"]
const _hoisted_42 = { key: 0 }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "App 링크", -1))
const _hoisted_44 = { class: "gal_info_con" }
const _hoisted_45 = ["href"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "멤버수", -1))
const _hoisted_47 = ["innerHTML"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "등록일자", -1))
const _hoisted_49 = { class: "gal_info_con" }
const _hoisted_50 = { class: "gal_info_list right" }
const _hoisted_51 = { class: "gal_info_item" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "gal_info_tit" }, "구분", -1))
const _hoisted_53 = ["onUpdate:modelValue"]
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 0 }, "선택해주세요.", -1))
const _hoisted_55 = ["value"]
const _hoisted_56 = { class: "gal_info_item" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "gal_info_tit" }, "업종", -1))
const _hoisted_58 = ["onUpdate:modelValue"]
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 0 }, "선택해주세요.", -1))
const _hoisted_60 = ["value"]
const _hoisted_61 = { class: "gal_info_item" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "gal_info_tit" }, "활성화 여부", -1))
const _hoisted_63 = { class: "chk" }
const _hoisted_64 = ["onUpdate:modelValue"]
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_66 = { class: "gal_info_item" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "gal_info_tit" }, "그루밍 성착취 의심", -1))
const _hoisted_68 = { class: "chk" }
const _hoisted_69 = ["onUpdate:modelValue"]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_71 = { class: "gal_info_item" }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = { class: "gal_top_box" }
const _hoisted_74 = { class: "gal_top_left" }
const _hoisted_75 = { class: "chk" }
const _hoisted_76 = ["value"]
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_78 = { class: "gal_thumb" }
const _hoisted_79 = { class: "gal_thumb_img" }
const _hoisted_80 = ["src", "onClick"]
const _hoisted_81 = { class: "gal_top_txt" }
const _hoisted_82 = { class: "gal_info_top_box" }
const _hoisted_83 = { class: "gal_info_top" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "순번", -1))
const _hoisted_85 = { class: "gal_info_div" }
const _hoisted_86 = { class: "gal_info_list" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "고유번호", -1))
const _hoisted_88 = { class: "gal_info_con" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "내용", -1))
const _hoisted_90 = ["innerHTML"]
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "링크", -1))
const _hoisted_92 = { class: "gal_info_con" }
const _hoisted_93 = ["href"]
const _hoisted_94 = { key: 0 }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "App 링크", -1))
const _hoisted_96 = { class: "gal_info_con" }
const _hoisted_97 = ["href"]
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "멤버수", -1))
const _hoisted_99 = ["innerHTML"]
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "등록일자", -1))
const _hoisted_101 = { class: "gal_info_con" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Filter = _resolveComponent("Filter")!
  const _component_NoResult = _resolveComponent("NoResult")!
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Popup = _resolveComponent("Popup")!
  const _component_SearchRoomModal = _resolveComponent("SearchRoomModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Header),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Filter, {
                sns: false,
                type: false,
                resultType: false,
                resultDetailType: false,
                nation: false,
                isMonitoring: false,
                platform: true,
                dateRange: false,
                gubun: true,
                industry: true,
                selectOption: $setup.state.selectOption,
                onSearch: $setup.filterSearch,
                onReset: $setup.resetSearch
              }, null, 8, ["selectOption", "onSearch", "onReset"]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "board_btn",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.toggleAll && $setup.toggleAll(...args)))
                  }, "전체선택"),
                  _createElementVNode("button", {
                    type: "button",
                    class: "board_btn board_ico_btn",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.excelDownLoad && $setup.excelDownLoad(...args)))
                  }, _hoisted_10)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString($setup.state.totalLength?.toLocaleString()) + "건", 1),
                  _withDirectives(_createElementVNode("select", {
                    class: "select",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.state.perPage) = $event)),
                    onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.changePerPage && $setup.changePerPage(...args)))
                  }, _hoisted_17, 544), [
                    [
                      _vModelSelect,
                      $setup.state.perPage,
                      void 0,
                      { number: true }
                    ]
                  ])
                ])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["gal_list_wrap", $setup.state.layer === 1 ? 'card' : ''])
              }, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.removeList && $setup.removeList(...args)))
                  }, "삭제"),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.showModal && $setup.showModal(...args)))
                  }, "등록")
                ]),
                (!$setup.state.isLoading)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      ($setup.result.list.length !== 0)
                        ? (_openBlock(), _createElementBlock("ul", {
                            key: 0,
                            class: _normalizeClass($setup.state.layer === 0 ? 'gal_list' : 'gal_list_v2')
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.result.list, (item, idx) => {
                              return (_openBlock(), _createElementBlock("li", null, [
                                _createElementVNode("div", {
                                  class: _normalizeClass($setup.state.layer === 0 ? 'gal_list_con' : 'gal_con')
                                }, [
                                  ($setup.state.layer === 0)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("label", _hoisted_19, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "checkbox",
                                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.state.checkList) = $event)),
                                              value: item.idx
                                            }, null, 8, _hoisted_20), [
                                              [_vModelCheckbox, $setup.state.checkList]
                                            ]),
                                            _hoisted_21
                                          ])
                                        ]),
                                        _createElementVNode("div", {
                                          class: "gal_thumb",
                                          onClick: ($event: any) => ($setup.isDetailModal(item))
                                        }, [
                                          _createElementVNode("div", _hoisted_23, [
                                            _createElementVNode("img", {
                                              class: _normalizeClass({ blur: item.photoUrl }),
                                              src: item.photoUrl ? item.photoUrl : require('@/assets/common/NoImg.png'),
                                              onError: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.imgError && $setup.imgError(...args)))
                                            }, null, 42, _hoisted_24)
                                          ])
                                        ], 8, _hoisted_22),
                                        _createElementVNode("div", _hoisted_25, [
                                          _createElementVNode("ul", _hoisted_26, [
                                            _createElementVNode("li", _hoisted_27, [
                                              _createElementVNode("div", _hoisted_28, [
                                                _hoisted_29,
                                                _createElementVNode("span", null, _toDisplayString($setup.state.currentPage === 1
                                                                                ? idx + 1
                                                                                : $setup.state.perPage * ($setup.state.currentPage - 1) + idx + 1), 1)
                                              ])
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_30,
                                              _createElementVNode("div", _hoisted_31, _toDisplayString(item.idx), 1)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_32,
                                              (item.platform === 1)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, "Telegram"))
                                                : (item.platform === 2)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, "Discord"))
                                                  : (item.platform === 4)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, "KakaoTalk"))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_36, "기타"))
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_37,
                                              _createElementVNode("div", {
                                                class: "gal_info_con",
                                                innerHTML: item.title
                                              }, null, 8, _hoisted_38)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_39,
                                              _createElementVNode("div", _hoisted_40, [
                                                _createElementVNode("a", {
                                                  href: item.link,
                                                  target: "_blank"
                                                }, _toDisplayString(item.link), 9, _hoisted_41)
                                              ])
                                            ]),
                                            (item.linkForApp)
                                              ? (_openBlock(), _createElementBlock("li", _hoisted_42, [
                                                  _hoisted_43,
                                                  _createElementVNode("div", _hoisted_44, [
                                                    _createElementVNode("a", {
                                                      href: item.linkForApp,
                                                      target: "_blank"
                                                    }, _toDisplayString(item.linkForApp), 9, _hoisted_45)
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("li", null, [
                                              _hoisted_46,
                                              _createElementVNode("div", {
                                                class: "gal_info_con",
                                                innerHTML: item.cntMembers?.toLocaleString()
                                              }, null, 8, _hoisted_47)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_48,
                                              _createElementVNode("div", _hoisted_49, _toDisplayString($setup.formatDate(item.createDate)), 1)
                                            ])
                                          ]),
                                          _createElementVNode("ul", _hoisted_50, [
                                            _createElementVNode("li", _hoisted_51, [
                                              _hoisted_52,
                                              _withDirectives(_createElementVNode("select", {
                                                class: "select",
                                                "onUpdate:modelValue": ($event: any) => ((item.gubun) = $event)
                                              }, [
                                                _hoisted_54,
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.options.gubun, (option) => {
                                                  return (_openBlock(), _createElementBlock("option", {
                                                    value: option.idx
                                                  }, _toDisplayString(option.name), 9, _hoisted_55))
                                                }), 256))
                                              ], 8, _hoisted_53), [
                                                [_vModelSelect, item.gubun]
                                              ])
                                            ]),
                                            _createElementVNode("li", _hoisted_56, [
                                              _hoisted_57,
                                              _withDirectives(_createElementVNode("select", {
                                                class: "select",
                                                "onUpdate:modelValue": ($event: any) => ((item.industry) = $event)
                                              }, [
                                                _hoisted_59,
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.options.industry, (option) => {
                                                  return (_openBlock(), _createElementBlock("option", {
                                                    value: option.idx
                                                  }, _toDisplayString(option.name), 9, _hoisted_60))
                                                }), 256))
                                              ], 8, _hoisted_58), [
                                                [_vModelSelect, item.industry]
                                              ])
                                            ]),
                                            _createElementVNode("li", _hoisted_61, [
                                              _hoisted_62,
                                              _createElementVNode("label", _hoisted_63, [
                                                _withDirectives(_createElementVNode("input", {
                                                  type: "checkbox",
                                                  "onUpdate:modelValue": ($event: any) => ((item.isActive) = $event),
                                                  "true-value": 1,
                                                  "false-value": 0
                                                }, null, 8, _hoisted_64), [
                                                  [_vModelCheckbox, item.isActive]
                                                ]),
                                                _hoisted_65
                                              ])
                                            ]),
                                            _createElementVNode("li", _hoisted_66, [
                                              _hoisted_67,
                                              _createElementVNode("label", _hoisted_68, [
                                                _withDirectives(_createElementVNode("input", {
                                                  type: "checkbox",
                                                  "onUpdate:modelValue": ($event: any) => ((item.isDoubt) = $event),
                                                  "true-value": 1,
                                                  "false-value": 0
                                                }, null, 8, _hoisted_69), [
                                                  [_vModelCheckbox, item.isDoubt]
                                                ]),
                                                _hoisted_70
                                              ])
                                            ]),
                                            _createElementVNode("li", _hoisted_71, [
                                              _createElementVNode("button", {
                                                type: "button",
                                                class: "deep_blue_btn",
                                                onClick: ($event: any) => ($setup.modify(item))
                                              }, " 저장 ", 8, _hoisted_72)
                                            ])
                                          ])
                                        ])
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  ($setup.state.layer === 1)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createElementVNode("div", _hoisted_73, [
                                          _createElementVNode("div", _hoisted_74, [
                                            _createElementVNode("label", _hoisted_75, [
                                              _withDirectives(_createElementVNode("input", {
                                                type: "checkbox",
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.state.checkList) = $event)),
                                                value: item.idx
                                              }, null, 8, _hoisted_76), [
                                                [_vModelCheckbox, $setup.state.checkList]
                                              ]),
                                              _hoisted_77
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_78, [
                                            _createElementVNode("div", _hoisted_79, [
                                              _createElementVNode("img", {
                                                class: _normalizeClass({ blur: item.photoUrl }),
                                                src: 
                                                                        item.photoUrl ? item.photoUrl : require('@/assets/common/NoImg.png')
                                                                    ,
                                                onError: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.imgError && $setup.imgError(...args))),
                                                onClick: ($event: any) => ($setup.isDetailModal(item))
                                              }, null, 42, _hoisted_80)
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_81, [
                                            _createElementVNode("div", null, [
                                              _createElementVNode("div", _hoisted_82, [
                                                _createElementVNode("p", _hoisted_83, [
                                                  _hoisted_84,
                                                  _createElementVNode("span", null, _toDisplayString($setup.state.currentPage === 1
                                                                                    ? idx + 1
                                                                                    : $setup.state.perPage * ($setup.state.currentPage - 1) + idx + 1), 1)
                                                ])
                                              ])
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_85, [
                                          _createElementVNode("ul", _hoisted_86, [
                                            _createElementVNode("li", null, [
                                              _hoisted_87,
                                              _createElementVNode("div", _hoisted_88, _toDisplayString(item.idx), 1)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_89,
                                              _createElementVNode("div", {
                                                class: "gal_info_con",
                                                innerHTML: item.title
                                              }, null, 8, _hoisted_90)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_91,
                                              _createElementVNode("div", _hoisted_92, [
                                                _createElementVNode("a", {
                                                  href: item.link,
                                                  target: "_blank"
                                                }, _toDisplayString(item.link), 9, _hoisted_93)
                                              ])
                                            ]),
                                            (item.linkForApp)
                                              ? (_openBlock(), _createElementBlock("li", _hoisted_94, [
                                                  _hoisted_95,
                                                  _createElementVNode("div", _hoisted_96, [
                                                    _createElementVNode("a", {
                                                      href: item.linkForApp,
                                                      target: "_blank"
                                                    }, _toDisplayString(item.linkForApp), 9, _hoisted_97)
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("li", null, [
                                              _hoisted_98,
                                              _createElementVNode("div", {
                                                class: "gal_info_con",
                                                innerHTML: item.cntMembers?.toLocaleString()
                                              }, null, 8, _hoisted_99)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_100,
                                              _createElementVNode("div", _hoisted_101, _toDisplayString($setup.formatDate(item.createDate)), 1)
                                            ])
                                          ])
                                        ])
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ], 2)
                              ]))
                            }), 256))
                          ], 2))
                        : (_openBlock(), _createBlock(_component_NoResult, {
                            key: 1,
                            class: "result_load"
                          })),
                      ($setup.result.list.length !== 0 && !$setup.state.isLoading)
                        ? (_openBlock(), _createBlock(_component_PageBtn, {
                            key: 2,
                            currentPage: $setup.state.currentPage,
                            totalLength: $setup.state.totalLength,
                            perPage: $setup.state.perPage,
                            onOnPaging: $setup.handlePageChange
                          }, null, 8, ["currentPage", "totalLength", "perPage", "onOnPaging"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createBlock(_component_Spinner, {
                      key: 1,
                      isLoading: $setup.state.isLoading,
                      class: "result_load"
                    }, null, 8, ["isLoading"]))
              ], 2)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Popup, {
      show: $setup.state.isModalOpen,
      title: $setup.modal.title,
      content: $setup.modal.content,
      onClose: $setup.modalClose
    }, null, 8, ["show", "title", "content", "onClose"]),
    ($setup.addModal.isShow)
      ? (_openBlock(), _createBlock(_component_SearchRoomModal, {
          key: 0,
          isEdit: $setup.addModal.isEdit,
          info: $setup.addModal.info,
          onClose: $setup.closeModal
        }, null, 8, ["isEdit", "info", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}